<div
	class="toast-box"
	role="status"
	aria-live="polite"
	aria-atomic="true"
	(mouseover)="pause.set(true)"
	(mouseout)="pause.set(false)"
>
	<div class="toast-content" [attr.borderColor]="display().color">
		<div class="toast-status-icon">
			<vis-icon [matIcon]="display().icon" [color]="display().color" size="l"></vis-icon>
		</div>
		<div class="toast-texts">
			<div class="toast-title" [innerHtml]="title()"></div>
			<div class="toast-message" [innerHtml]="message()"></div>
		</div>
		<div
			class="toast-progress-bar"
			[style.animation-duration.ms]="duration()"
			[style.animation-play-state]="pause() ? 'paused' : 'running'"
		></div>
	</div>
</div>
